import { render, staticRenderFns } from "./ResizablePanel.vue?vue&type=template&id=06c18400&scoped=true&"
import script from "./ResizablePanel.vue?vue&type=script&lang=js&"
export * from "./ResizablePanel.vue?vue&type=script&lang=js&"
import style0 from "./ResizablePanel.vue?vue&type=style&index=0&id=06c18400&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c18400",
  null
  
)

export default component.exports